import React from 'react';
import Column from '@splunk/dashboard-visualizations/Column';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import EventsDoc from '@splunk/dashboard-visualizations/common/EventsDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicExampleCode from '!!raw-loader!./examples/Basic';
import TitleSpecifiedCode from '!!raw-loader!./examples/TitleSpecified';
import TitleNotVisibleCode from '!!raw-loader!./examples/TitleNotVisible';
import SeriesColorsCode from '!!raw-loader!./examples/SeriesColors';
import FieldColorsCode from '!!raw-loader!./examples/FieldColors';
import BackgroundColorCode from '!!raw-loader!./examples/BackgroundColor';
import ForegroundColorCode from '!!raw-loader!./examples/ForegroundColor';
import FontColorCode from '!!raw-loader!./examples/FontColor';
import SplitSeriesCode from '!!raw-loader!./examples/SplitSeries';
import SplitSeriesIndependentCode from '!!raw-loader!./examples/SplitSeriesIndependent';
import StackModeCode from '!!raw-loader!./examples/StackMode';
import FieldShowListCode from '!!raw-loader!./examples/FieldShowList';
import AxisYAbbreviationCode from '!!raw-loader!./examples/AxisYAbbreviation';
import AxisYScaleCode from '!!raw-loader!./examples/AxisYScale';
import ExtendRangeCode from '!!raw-loader!./examples/ExtendRange';
import IncludeZeroCode from '!!raw-loader!./examples/IncludeZero';
import AxisXLabelVisibilityCode from '!!raw-loader!./examples/AxisXLabelVisibility';
import AxisYLabelVisiblilityCode from '!!raw-loader!./examples/AxisYLabelVisiblility';
import AxisXMajorTickLabelsCode from '!!raw-loader!./examples/AxisXMajorTickLabels';
import AxisYMajorTickLabelsCode from '!!raw-loader!./examples/AxisYMajorTickLabels';
import MajorGridCode from '!!raw-loader!./examples/MajorGrid';
import MinorGridCode from '!!raw-loader!./examples/MinorGrid';
import LegendCode from '!!raw-loader!./examples/Legend';
import LegendStyleModeCode from '!!raw-loader!./examples/LegendStyleMode';
import DataLabelsCode from '!!raw-loader!./examples/DataLabels';
import TicksCode from '!!raw-loader!./examples/Ticks';
import ColumnSpacingCode from '!!raw-loader!./examples/ColumnSpacing';
import SeriesSpacingCode from '!!raw-loader!./examples/SeriesSpacing';
import ColumnGroupingCode from '!!raw-loader!./examples/ColumnGrouping';
import ChartOverlayCode from '!!raw-loader!./examples/ChartOverlay';
import LineWidthCode from '!!raw-loader!./examples/LineWidth';
import AnnotationExampleCode from '!!raw-loader!./examples/Annotation';
import AnnotationColorExampleCode from '!!raw-loader!./examples/AnnotationColor';
import MultiSeriesExplicitCode from '!!raw-loader!./examples/MultiSeriesExplicit';
import MultiSeriesDynamicCode from '!!raw-loader!./examples/MultiSeriesDynamic';
import MultiYAxesCode from '!!raw-loader!./examples/MultiYAxes';

import BasicExample from './examples/Basic';
import TitleSpecifiedExample from './examples/TitleSpecified';
import TitleNotVisibleExample from './examples/TitleNotVisible';
import SeriesColorsExample from './examples/SeriesColors';
import FieldColorsExample from './examples/FieldColors';
import BackgroundColorExample from './examples/BackgroundColor';
import ForegroundColorExample from './examples/ForegroundColor';
import FontColorExample from './examples/FontColor';
import SplitSeriesExample from './examples/SplitSeries';
import SplitSeriesIndependentExample from './examples/SplitSeriesIndependent';
import AxisYAbbreviationExample from './examples/AxisYAbbreviation';
import StackModeExample from './examples/StackMode';
import FieldShowListExample from './examples/FieldShowList';
import AxisYScaleExample from './examples/AxisYScale';
import ExtendRangeExample from './examples/ExtendRange';
import IncludeZeroExample from './examples/IncludeZero';
import AxisXLabelVisibilityExample from './examples/AxisXLabelVisibility';
import AxisYLabelVisiblilityExample from './examples/AxisYLabelVisiblility';
import AxisXMajorTickLabelsExample from './examples/AxisXMajorTickLabels';
import AxisYMajorTickLabelsExample from './examples/AxisYMajorTickLabels';
import MajorGridExample from './examples/MajorGrid';
import MinorGridExample from './examples/MinorGrid';
import LegendExample from './examples/Legend';
import LegendStyleModeExample from './examples/LegendStyleMode';
import DataLabelsExample from './examples/DataLabels';
import TicksExample from './examples/Ticks';
import ColumnSpacingExample from './examples/ColumnSpacing';
import SeriesSpacingExample from './examples/SeriesSpacing';
import ColumnGroupingExample from './examples/ColumnGrouping';
import ChartOverlayExample from './examples/ChartOverlay';
import LineWidthExample from './examples/LineWidth';
import AnnotationExample from './examples/Annotation';
import AnnotationColorExample from './examples/AnnotationColor';
import MultiSeriesExplicitExample from './examples/MultiSeriesExplicit';
import MultiSeriesDynamicExample from './examples/MultiSeriesDynamic';
import MultiYAxesExample from './examples/MultiYAxes';
import doc from './definition';
import optionsSchema from '../optionsSchema';

export default () => (
    <VisualizationDocPage
        title="Column"
        examplesSection={[
            <DocExample title="Basic Column" key="basic" code={BasicExampleCode} example={BasicExample} />,
            <DocExample
                title="Annotation"
                key="annotation"
                code={AnnotationExampleCode}
                example={AnnotationExample}
            />,
            <DocExample
                title="Annotation Category Color"
                key="annotationcolor"
                code={AnnotationColorExampleCode}
                example={AnnotationColorExample}
            />,
            <DocExample
                title="Axis Y and X Title specified"
                key="titlespecified"
                code={TitleSpecifiedCode}
                example={TitleSpecifiedExample}
            />,
            <DocExample
                title="Axis Y and X Title not visible"
                key="titlenotvisible"
                code={TitleNotVisibleCode}
                example={TitleNotVisibleExample}
            />,
            <DocExample
                title="Series Colors: Red and Blue"
                key="seriescolors"
                code={SeriesColorsCode}
                example={SeriesColorsExample}
            />,
            <DocExample
                title="Field colors: Count - Green, Percent - Orange"
                key="fieldcolors"
                code={FieldColorsCode}
                example={FieldColorsExample}
            />,
            <DocExample
                title="Background Color - Green"
                key="backgroundcolor"
                code={BackgroundColorCode}
                example={BackgroundColorExample}
            />,
            <DocExample
                title="Foreground Color - Red"
                key="foregroundcolor"
                code={ForegroundColorCode}
                example={ForegroundColorExample}
            />,
            <DocExample
                title="Font Color - Blue"
                key="fontcolor"
                code={FontColorCode}
                example={FontColorExample}
            />,
            <DocExample
                title="Split Series - True"
                key="splitseries"
                code={SplitSeriesCode}
                example={SplitSeriesExample}
            />,
            <DocExample
                title="Split Series and Split Series Independent - True"
                key="splitseriesindependent"
                code={SplitSeriesIndependentCode}
                example={SplitSeriesIndependentExample}
            />,
            <DocExample
                title="Stack Mode - Stacked"
                key="stackmode"
                code={StackModeCode}
                example={StackModeExample}
            />,
            <DocExample
                title="Field Show List - Percent"
                key="fieldshowlist"
                code={FieldShowListCode}
                example={FieldShowListExample}
            />,
            <DocExample
                title="Axis-Y Abbreviation - On"
                key="axisyabbreviation"
                code={AxisYAbbreviationCode}
                example={AxisYAbbreviationExample}
            />,
            <DocExample
                title="Axis-Y Scale - Log"
                key="axisyscale"
                code={AxisYScaleCode}
                example={AxisYScaleExample}
            />,
            <DocExample
                title="Axis-Y Extend Axis Range - False"
                key="extendrange"
                code={ExtendRangeCode}
                example={ExtendRangeExample}
            />,
            <DocExample
                title="Axis-Y Include Zero - True"
                key="includezero"
                code={IncludeZeroCode}
                example={IncludeZeroExample}
            />,
            <DocExample
                title="Axis-X - Show"
                key="axisxlabelvisibility"
                code={AxisXLabelVisibilityCode}
                example={AxisXLabelVisibilityExample}
            />,
            <DocExample
                title="Axis-Y - Show"
                key="axisylabelvisiblility"
                code={AxisYLabelVisiblilityCode}
                example={AxisYLabelVisiblilityExample}
            />,
            <DocExample
                title="Axis-X Major Tick Labels - Hide"
                key="axisxmajorticklabels"
                code={AxisXMajorTickLabelsCode}
                example={AxisXMajorTickLabelsExample}
            />,
            <DocExample
                title="Axis-Y Major Tick Labels - Hide"
                key="axisymajorticklabels"
                code={AxisYMajorTickLabelsCode}
                example={AxisYMajorTickLabelsExample}
            />,
            <DocExample
                title="Axis-Y Major Grid - False, Axis-X Major Grid - True"
                key="majorgrid"
                code={MajorGridCode}
                example={MajorGridExample}
            />,
            <DocExample
                title="Axis-Y Minor Grid - True"
                key="minorgrid"
                code={MinorGridCode}
                example={MinorGridExample}
            />,
            <DocExample
                title="Axis-Y Major, Minor Ticks - Show (15, 10), Axis-X - Hide"
                key="ticks"
                code={TicksCode}
                example={TicksExample}
            />,
            <DocExample
                title="Column Spacing - 10"
                key="columnspacing"
                code={ColumnSpacingCode}
                example={ColumnSpacingExample}
            />,
            <DocExample
                title="Series Spacing - 5"
                key="seriesspacing"
                code={SeriesSpacingCode}
                example={SeriesSpacingExample}
            />,
            <DocExample
                title="Column Grouping - Overlay"
                key="columngrouping"
                code={ColumnGroupingCode}
                example={ColumnGroupingExample}
            />,
            <DocExample
                title="New Legend Labels, Legend Labels Placement - Top"
                key="legend"
                code={LegendCode}
                example={LegendExample}
            />,
            <DocExample
                title="Very Long Legend Labels, Legend Style Mode - End"
                key="legendstylemode"
                code={LegendStyleModeCode}
                example={LegendStyleModeExample}
            />,
            <DocExample
                title="Data Labels - All"
                key="datalabels"
                code={DataLabelsCode}
                example={DataLabelsExample}
            />,
            <DocExample
                title="Chart Overlay - On, Axis-Y2 Title specified, Abbreviation - On"
                key="chartoverlay"
                code={ChartOverlayCode}
                example={ChartOverlayExample}
            />,
            <DocExample
                title="Chart Overlay - On, Line Width - 5"
                key="inewidth"
                code={LineWidthCode}
                example={LineWidthExample}
            />,
            <DocExample
                title="Multi Series - Explicit encoding"
                key="multiseriesexplicit"
                code={MultiSeriesExplicitCode}
                example={MultiSeriesExplicitExample}
            />,
            <DocExample
                title="Multi Series - Dynamic encoding"
                key="multiseriesdynamic"
                code={MultiSeriesDynamicCode}
                example={MultiSeriesDynamicExample}
            />,
            <DocExample
                title="Multi Y Axes"
                key="multiyaxes"
                code={MultiYAxesCode}
                example={MultiYAxesExample}
            />,
        ]}
        encodingSection={<EncodingDoc encoding={doc.encoding} />}
        optionSection={<OptionsDoc options={optionsSchema} />}
        eventSection={
            <EventsDoc
                encoding={{
                    x: 'primary._time',
                    y: 'primary.count',
                }}
                events={doc.events}
                Visualization={Column}
                dsState={{
                    primary: {
                        requestParams: { offset: 0, count: 20 },
                        data: {
                            fields: [
                                { name: '_time', groupby_rank: '0' },
                                { name: 'count' },
                                { name: '_span' },
                            ],
                            columns: [
                                [
                                    '2018-05-02T18:15:46.000-07:00',
                                    '2018-05-02T18:15:47.000-07:00',
                                    '2018-05-02T18:15:48.000-07:00',
                                    '2018-05-02T18:15:49.000-07:00',
                                    '2018-05-02T18:15:50.000-07:00',
                                ],
                                ['2', '10', '13', '60', '43', '85'],
                                ['1', '1', '1', '1', '1', '1'],
                            ],
                        },
                        meta: { totalCount: 20 },
                    },
                }}
            />
        }
    />
);
